import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '!isomorphic-style-loader/!css-loader!react-geosuggest/module/geosuggest.css';
import { stub } from 'mocktail';

const styleOrStub = stub(withStyles(s), d => {
  return d;
});
export default styleOrStub;



// WEBPACK FOOTER //
// ./src/components/SearchListing/PlacesSuggest/PlacesSuggest.styles.js